import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux'
import { fetch } from '../../actions'
import { useFetchPost, useFetchPostV2, useSavePost } from '../../components/Hooks/Conexao'
import Menu from '../Shared/Menu'
import { Button, Icon, Tabs, Input, Checkbox, Modal, Typography } from 'antd';
import Spinner from '../../components/Spinner/Spinner';
import { SubTitulo, LoadingScreen, IconCheck, IconError } from '../../components/Diversos';
import moment from 'moment'

const { Paragraph } = Typography;
const { TextArea } = Input;

function Content(props) {
    return (<div className="popover-padrao">
    <div onClick={() => props.onClick('det', props.conn, props.id)}>Detalhes</div>
    {/* <div>Editar</div> */}
</div>)
}

function Func(props)  {
    
    const [dadosDet, setDadosDet] = useState(null)
   
    const [dados, listar, loading, setDados] = useFetchPostV2(props.fetch, '/log', { modelo: 'all' })
    const [dadosLog, listarLog, loadingLog] = useFetchPostV2(props.fetch, '/log', { modelo: 'log-det', id: dadosDet })

    useEffect(() => { 
        listar();    
    }, []);

    useEffect(() => { 
        if(dadosDet){
            listarLog();    
        }
    }, [dadosDet]);
   
    return(
        <>  
            <Menu />
            {/* <LoadingScreen loading={loading} /> */}
            <div style={{textAlign:'center', marginTop:15}}><h2>Logs</h2></div>

            { loading && <div style={{marginTop:40}}><Spinner /></div> }
            { !loading && dados &&  (
            <>
                {/* <pre>{JSON.stringify(dados, null, 2)}</pre> */}
                <div className="tabela-wrapper">
                    <table className="tabela-padrao">
                        <thead>
                            <tr>
                                <th className="text-left">Nome</th>
                                <th className="text-center">Data</th>
                                <th className="text-left">Modelo</th>
                                <th className="text-left">Operação</th>
                                <th className="text-left">Info</th>
                                <th className="text-left">Mensagem</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(dados || []).map((v, inx) =>{
                                return(
                                    <tr key={v.id} onClick={() => setDadosDet(v.id)} style={{cursor:'pointer'}}>
                                        <td className="text-left">{v.nome}</td>
                                        <td className="text-center">{moment(v.data).format('DD/MM/YYYY HH:mm:ss')}</td>
                                        <td className="text-left">{v.modelo}</td>
                                        <td className="text-left">{v.operacao}</td>
                                        <td className="text-left">{v.info}</td>
                                        <td className="text-left" style={{maxWidth:250, overflow:'hidden', whiteSpace:'nowrap', textOverflow:'ellipsis'}} title={v.msg}>{v.msg}</td>
                                    </tr>
                                )
                            })}               
                        </tbody>
                    </table>
                </div>
            </>)}

            <Modal
                title="Detalhes"
                visible={!(!dadosDet)}
                onCancel={() => setDadosDet(null)}
                cancelText="Sair"
                footer={[ <Button key="back" type="primary" ghost onClick={() => setDadosDet(null)}>Sair</Button>  ]} 
                width={1100}
                >
                   {loadingLog ? <Spinner /> : (
                       <div>
                           <Input value={dadosLog ? dadosLog.Msg : null} style={{marginBottom:20}} />
                           <div style={{textAlign:'right'}}>
                                <Paragraph copyable={{ text: dadosLog ? dadosLog.MsgDet : null }} style={{marginBottom:5}}>Copiar</Paragraph>
                           </div>
                           <TextArea rows={18} value={dadosLog ? dadosLog.MsgDet : null} />
                       </div>
                   )}
            </Modal>
        </>
    )
}

export default connect(null, { fetch })(Func);